import { u, styled } from '../../../../shared/theming-sc'

const SearchWrapper = styled.div`
    width: 240px;
    height: ${u.getSpacing('large')}px;
    float: right;
    border: 1px solid ${u.getColor('greyMuted')};
    border-radius: 5px;
    padding: 0 ${u.getSpacing('large')}px 0 ${u.getSpacing('smaller')}px;
    box-sizing: border-box;
    position: relative;
    display: none;

    ${u.media.greaterThan('lg')`
       display: block;
    `};

    /* DT: sorry about this... */
    &.focus {
        border: 1px solid ${u.getColor('greyDark')};
    }
`

const SearchWrapperFocus = styled.div`
     width: 240px;
    height: ${u.getSpacing('large')}px;
    float: right;
    border: 1px solid ${u.getColor('greyDark')};
    border-radius: 5px;
    padding: 0 ${u.getSpacing('large')}px 0 ${u.getSpacing('smaller')}px;
    box-sizing: border-box;
    position: relative;
    display: none;

    ${u.media.greaterThan('lg')`
       display: block;
    `};
`

const TextInput = styled.input`
    width: 100%;
    font-size: ${u.getFontSize('md')};
    margin-top: ${u.getSpacing('tiny')}px;
    color: ${u.getColor('greyDark')};
    border: none;
    background: white;
    outline: none;

    &:focus{
        ::placeholder{
            color: rgba(0, 0, 0, 0)
        }
    }

    &::-ms-clear {
        display: none;
        height: 0;
        width: 0;
    }
`

const IconContainer = styled.a`
    width: 20px;
    height: 20px;
    position: absolute;
    right: ${u.getSpacing('smaller')}px;
    top: ${u.getSpacing('smaller')}px;
    display: block;

    svg {
        path {
            stroke: ${u.getColor('grey')};
        }

        circle {
            stroke: ${u.getColor('grey')};
        }
    }
`

export {
  SearchWrapper,
  SearchWrapperFocus,
  TextInput,
  IconContainer
}
